"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndustrialComplex = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const PreludeCard_1 = require("../prelude/PreludeCard");
const Tags_1 = require("../Tags");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const Resources_1 = require("../../Resources");
class IndustrialComplex extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.INDUSTRIAL_COMPLEX,
            tags: [Tags_1.Tags.BUILDING],
            metadata: {
                cardNumber: 'P52',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.megacredits(-18);
                    b.production((pb) => pb.wild(1)).asterix();
                }),
                description: 'Lose 18 M€. INCREASE ALL YOUR PRODUCTIONS THAT ARE LOWER THAN 1, TO 1.',
            },
        });
    }
    canPlay(player) {
        return player.canAfford(18);
    }
    play(player) {
        this.produce(player);
        player.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 18, { title: 'Select how to pay for Industrial Complex' }), DeferredAction_1.Priority.LOSE_RESOURCE_OR_PRODUCTION);
        return undefined;
    }
    produce(player) {
        [Resources_1.Resources.MEGACREDITS, Resources_1.Resources.STEEL, Resources_1.Resources.TITANIUM, Resources_1.Resources.PLANTS, Resources_1.Resources.ENERGY, Resources_1.Resources.HEAT].forEach((resource) => {
            const production = player.getProduction(resource);
            if (production < 1)
                player.addProduction(resource, 1 - production);
        });
    }
}
exports.IndustrialComplex = IndustrialComplex;
//# sourceMappingURL=IndustrialComplex.js.map